'use client'

import textBodyLinkM from '@fukku/styles/texts/textBodyLinkM.module.css'
import { cx } from 'classix'
import { TEST_IDS } from 'labels/constants/testIds'
import styles from '../GenericStyles.module.css'

export type ClientButtonProps = Readonly<
	React.ButtonHTMLAttributes<HTMLButtonElement>
>

export function ClientButton(props: ClientButtonProps): React.ReactElement {
	const { className, children, ...rest } = props

	return (
		<button
			data-testid={TEST_IDS.BUTTON}
			type='button'
			className={cx(className, textBodyLinkM.className, styles.button)}
			{...rest}
		>
			{children}
		</button>
	)
}
